var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14Z",
    fill: "#2A254B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z",
    fill: "#2A254B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.50001H2.91L2.5 0.40001C2.47662 0.285372 2.41379 0.182561 2.32243 0.109474C2.23107 0.0363867 2.11697 -0.0023488 2 1.01668e-05H0V1.00001H1.59L3.5 10.6C3.52338 10.7146 3.58621 10.8175 3.67757 10.8905C3.76893 10.9636 3.88303 11.0024 4 11H13V10H4.41L4 8.00001H13C13.1156 8.00284 13.2286 7.96552 13.3197 7.89441C13.4109 7.8233 13.4746 7.7228 13.5 7.61001L14.5 3.11001C14.5168 3.03582 14.5164 2.95879 14.4989 2.88478C14.4814 2.81076 14.4472 2.74172 14.399 2.6829C14.3508 2.62407 14.2898 2.57703 14.2206 2.54534C14.1515 2.51364 14.076 2.49814 14 2.50001ZM12.6 7.00001H3.81L3.11 3.50001H13.375L12.6 7.00001Z",
    fill: "#2A254B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.9fe71cbc48acd439df8ffd0d61f0fb4d.svg";
export { ForwardRef as ReactComponent };